/**
 * Converts something into an error, to ensure errors can be handled as Errors in catch blocks.
 * Since anything can be thrown in JS, Typescript treats errors in catch blocks as `unknown` by default.
 * */
export function asError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error));
}
